import { render, staticRenderFns } from "./ToDoCard.vue?vue&type=template&id=2d4db502"
import script from "./ToDoCard.vue?vue&type=script&lang=js"
export * from "./ToDoCard.vue?vue&type=script&lang=js"
import style0 from "./ToDoCard.vue?vue&type=style&index=0&id=2d4db502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports